import { Capacitor } from "@capacitor/core"

type ReturnType = "web" | "android" | "ios"

export function useWebPlatform() {
	return Capacitor.getPlatform() as ReturnType
}
